// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/close_times_circle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

.mobile-window__header,
.mobile-window__footer {
    display: none;
    padding: 20px;
    box-sizing: border-box;
}

.mobile-window.mobile-window__pc-side.mobile-window_inactive {
    display: none;
}

.mobile-window.mobile-window__pc-side.mobile-window_active {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    padding: 0;
    display: flex;
    width: 50vw;
    max-width: 600px;
    flex-direction: column;
    justify-content: stretch;
    background-color: #ffffff;
    z-index: 100;
    box-shadow: -15px 0 10px 5px rgba(0, 0, 0, 0.2);
}

.mobile-window__header {
    font-size: 24px;
    font-weight: 700;
    flex: 0 0 auto;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.mobile-window.mobile-window__pc-side.mobile-window_active .mobile-window__header {
    display: flex;
}

.mobile-window.mobile-window__pc-side.mobile-window_active .mobile-window__footer {
    display: block;
}

.mobile-window.mobile-window__pc-side.mobile-window_inactive {
    display: none;
}

.mobile-window.mobile-window__pc-none{
    display: none;
}

.mobile-window__close {
    width: 30px;
    height: 30px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
}

@media screen and (max-width: 1024px) {

    .mobile-window,
    .mobile-window.mobile-window__pc-none.mobile-window_active,
    .mobile-window.mobile-window__pc-side,
    .mobile-window.mobile-window__pc-side.mobile-window_active {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        background-color: #ffffff;
        z-index: 100;
        width: auto;
        box-shadow: none;
        padding-bottom:68px;
    }

    .mobile-window__header {
        flex: 0 0 auto;
        display: flex;
        font-size: 16px;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .mobile-window__title {
        font-weight: bold;
    }

    .mobile-window__close {
        width: 30px;
        height: 30px;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        background-repeat: no-repeat;
        background-size: contain;
    }

    .mobile-window__content {
        flex: 1 1 auto;
        overflow-y: auto;
    }

    .mobile-window__footer {
        display: flex;
        flex: 0 0 auto;
    }

    .mobile-window__ok {

    }

    .mobile-window_active {
        display: flex;
    }

    .mobile-window_inactive {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./resources/assets/site/css/mobile.window.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;;IAEI,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,SAAS;IACT,UAAU;IACV,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAAoD;IACpD,4BAA4B;IAC5B,wBAAwB;IACxB,eAAe;AACnB;;AAEA;;IAEI;;;;QAII,eAAe;QACf,MAAM;QACN,OAAO;QACP,QAAQ;QACR,SAAS;QACT,SAAS;QACT,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,wBAAwB;QACxB,yBAAyB;QACzB,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,aAAa;QACb,eAAe;QACf,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yDAAoD;QACpD,4BAA4B;QAC5B,wBAAwB;IAC5B;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;;IAEA;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["@charset \"UTF-8\";\n\n.mobile-window__header,\n.mobile-window__footer {\n    display: none;\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n.mobile-window.mobile-window__pc-side.mobile-window_inactive {\n    display: none;\n}\n\n.mobile-window.mobile-window__pc-side.mobile-window_active {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    width: 50vw;\n    max-width: 600px;\n    flex-direction: column;\n    justify-content: stretch;\n    background-color: #ffffff;\n    z-index: 100;\n    box-shadow: -15px 0 10px 5px rgba(0, 0, 0, 0.2);\n}\n\n.mobile-window__header {\n    font-size: 24px;\n    font-weight: 700;\n    flex: 0 0 auto;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.mobile-window.mobile-window__pc-side.mobile-window_active .mobile-window__header {\n    display: flex;\n}\n\n.mobile-window.mobile-window__pc-side.mobile-window_active .mobile-window__footer {\n    display: block;\n}\n\n.mobile-window.mobile-window__pc-side.mobile-window_inactive {\n    display: none;\n}\n\n.mobile-window.mobile-window__pc-none{\n    display: none;\n}\n\n.mobile-window__close {\n    width: 30px;\n    height: 30px;\n    background-image: url(../img/close_times_circle.svg);\n    background-repeat: no-repeat;\n    background-size: contain;\n    cursor: pointer;\n}\n\n@media screen and (max-width: 1024px) {\n\n    .mobile-window,\n    .mobile-window.mobile-window__pc-none.mobile-window_active,\n    .mobile-window.mobile-window__pc-side,\n    .mobile-window.mobile-window__pc-side.mobile-window_active {\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        margin: 0;\n        padding: 0;\n        display: flex;\n        flex-direction: column;\n        justify-content: stretch;\n        background-color: #ffffff;\n        z-index: 100;\n        width: auto;\n        box-shadow: none;\n        padding-bottom:68px;\n    }\n\n    .mobile-window__header {\n        flex: 0 0 auto;\n        display: flex;\n        font-size: 16px;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .mobile-window__title {\n        font-weight: bold;\n    }\n\n    .mobile-window__close {\n        width: 30px;\n        height: 30px;\n        background-image: url(../img/close_times_circle.svg);\n        background-repeat: no-repeat;\n        background-size: contain;\n    }\n\n    .mobile-window__content {\n        flex: 1 1 auto;\n        overflow-y: auto;\n    }\n\n    .mobile-window__footer {\n        display: flex;\n        flex: 0 0 auto;\n    }\n\n    .mobile-window__ok {\n\n    }\n\n    .mobile-window_active {\n        display: flex;\n    }\n\n    .mobile-window_inactive {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
